<div *ngIf="group" [formGroup]="group" class="form-group">
    <label *ngIf="textLabel" [for]="fcName+i" [ngClass]="{'star' : required}" class="label-info">{{textLabel}} </label>
    <ng-container *ngIf="templateLabel" [ngTemplateOutlet]="templateLabel"></ng-container>
    <input [formControlName]="fcName"
           [id]="fcName + i"
           [name]="fcName + i"
           [ngClass]="{'is-invalid': isInvalid()}"
           [pattern]="pattern"
           [placeholder]="placeholder"
           autocomplete="off"
           class="form-control">

    <div *ngIf="isInvalid() && (errorMsg || errorMsg2)" class="invalid-feedback d-block">
        <div *ngIf="control.errors.required else otherError">{{errorMsg}}</div>
        <ng-template #otherError>{{errorMsg2}}</ng-template>
    </div>
</div>
<div *ngIf="!group" class="form-group">
    <label *ngIf="textLabel" [for]="fcName+i" [ngClass]="{'star' : required}" class="label-info">{{textLabel}}</label>
    <ng-container *ngIf="templateLabel" [ngTemplateOutlet]="templateLabel"></ng-container>
    <input [id]="fcName + i" [name]="fcName + i"
           [placeholder]="placeholder"
           autocomplete="off"
           class="form-control"
           type="search">
</div>
